/* 關張傳・第 3 章：刮骨療毒（年份不詳，約建安二十年至二十四年）
 * 史實：《三國志·關羽傳》「羽嘗為流矢所中，貫其左臂，後創雖愈，每至陰雨，骨常疼痛，醫曰：『矢鏃有毒，毒入於骨，當破臂作創，
 *       刮骨去毒，然後此患乃除耳。』羽便伸臂令醫劈之。時羽適請諸將飲食相對，臂血流離，盈於盤器，而羽割炙引酒，言笑自若。」
 *       （醫者正史不具名；演義寫成華佗，華佗此前已死。）
 * 流程：不打仗的一章。
 *       1. 陰雨：舊創發作（走得慢），到醫帳聽醫者說明。
 *       2. 請諸將：營中三位將領，走過去請他們入席（可以不請，少一顆星）。
 *       3. 伸臂令醫劈之：坐到席上，醫者一刀刀劈、刮。每一下畫面先跳出「割炙（Q）」「引酒（W）」「言笑（E）」，時限內按對才保得住威儀；
 *          這一章技能鍵不放招，改成這三個動作。一動就是「莫動」，醫者停手、威儀大減，要坐回去。威儀歸零是色變，失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel } from '../kit.ts';
import { rain } from './guanzhang_kit.ts';
import { TABLE, SEAT, DOCTOR, GENS } from '../maps/guanzhang_jiangling_ying.ts';

const LV = 14, CUTS = 14, ACTS = ['割炙（Q）', '引酒（W）', '言笑（E）'];
const TALK = [['部將', '將軍，這一刀……'], ['關羽', '來，飲！'], ['部將', '聽說益州那邊，翼德又打了勝仗。'], ['關羽', '孟起雖勇，猶未及髯之絕倫逸群也。哈哈！'], ['部將', '將軍面不改色，末將佩服。'], ['關羽', '這炙肉烤得好。']];

export default {
  id: 'guanzhang-3', map: 'guanzhang_jiangling_ying', hero: 'guanyu', gold: 0,
  title: '第 3 章　刮骨療毒', year: '年份不詳（約 215–219）',
  brief: {
    quote: [{ text: '羽便伸臂令醫劈之。時羽適請諸將飲食相對，臂血流離，盈於盤器，而羽割炙引酒，言笑自若。', src: '《三國志·蜀書·關羽傳》' }],
    text: '劉備西定益州，拜關羽董督荊州事。關羽早年左臂中過流矢，箭貫臂而過，傷口雖然好了，每到陰雨天骨頭還是痛。（醫者正史沒有留下名字；演義寫成華佗，是小說家言。）',
    goals: ['陰雨：到醫帳聽醫者怎麼說', '請諸將入席飲食', '伸臂令醫劈之：照提示割炙、引酒、言笑，言笑自若'],
  },
  words: { ally: '諸將', foe: '' },
  stars: [
    { text: '言笑自若：威儀保有八成以上', ok: (m) => m.vars.poise >= 80 },
    { text: '一刀都沒漏：每個提示都按對', ok: (m) => m.vars.miss === 0 },
    { text: '請齊三位將領才開刀', ok: (m) => m.vars.invitedAtStart === 3 },
  ],
  steps: [
    { // 0. 陰雨，骨常疼痛
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = 3000; me.y = 2900;
        V.rain = 1; V.invited = 0; V.poise = 100; V.miss = 0; V.blood = 0;
        w.addBuff(me, { id: '舊創', t: 9999, ms: -0.25, as: -0.3, neg: true });
        V.doc = m.folk(DOCTOR[0], DOCTOR[1], { name: '醫', still: true, near: 170, look: 2, lines: [
          ['醫', '將軍這條臂，是當年流矢貫穿的吧。'],
          ['醫', '矢鏃有毒，毒入於骨，當破臂作創，刮骨去毒，然後此患乃除耳。'],
          ['關羽', '那就劈吧。'],
        ], onHeard: () => { V.heard = true; } });
        V.gens = GENS.map(([x, y], k) => m.folk(x, y, { name: '部將', still: true, near: 160, look: k + 1, lines: [['部將', ['將軍有何吩咐？', '雨下得人骨頭都酸了。', '末將這就來！'][k]], ['關羽', '入帳來，陪我飲幾杯。']], onHeard: (f) => { f.invited = true; V.invited++; f.x = TABLE[0] + [-160, 160, 0][k]; f.y = TABLE[1] + [-40, -40, -120][k]; f.home = [f.x, f.y]; m.unmark('g' + k); } }));
        m.line('關羽', '……又下雨了。這條臂，每逢陰雨就痛到骨子裡。');
        m.after(3, () => m.line('提示', '舊創發作，走得慢、出手也慢。到醫帳找醫者。'));
        m.mark('doc', DOCTOR[0], DOCTOR[1], '醫帳');
        m.obj('doc', '到醫帳聽醫者說明');
      },
      tick(m) { return !!m.vars.heard; },
    },
    { // 1. 請諸將飲食相對
      enter(m, w) {
        const V = m.vars;
        m.done('doc'); m.unmark('doc');
        V.gens.forEach((f, k) => { if (!f.invited) m.mark('g' + k, f.x, f.y, '部將', true); });
        m.mark('seat', SEAT[0], SEAT[1], '入席');
        m.after(1.5, () => m.line('提示', '先到營中各處請將領入席（可以不請），然後到席上坐下（站著不動），伸臂讓醫者劈開。'));
        m.obj('gens', '請諸將入席', 3);
        m.obj('seat', '入席，伸臂令醫劈之');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.prog('gens', V.invited);
        m.chanAt(me, 'sit', SEAT[0], SEAT[1], 120, 1, '入席', () => { V.sat = true; });
        return !!V.sat;
      },
    },
    { // 2. 刮骨
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('seat'); m.unmark('seat');
        V.gens.forEach((f, k) => m.unmark('g' + k));
        V.invitedAtStart = V.invited;
        V.surgery = true; V.sitting = true; V.cut = 0; V.cue = null; V.nextT = 2.5; V.at = [me.x, me.y];
        for (let i = 0; i < 3; i++) if (!me.skillLv[i]) me.skillLv[i] = 1; // 三個動作用 Q、W、E
        V.doc.x = SEAT[0] + 90; V.doc.y = SEAT[1] + 20; V.doc.home = [V.doc.x, V.doc.y]; V.doc.lines = null;
        // 這一章技能鍵不放招：包住這個世界的 tryCast，主角按下的鍵當成動作
        const tc = w.tryCast;
        w.tryCast = function (u, i, x, y) { if (u === w.player && V.surgery) { press(m, w, i); return true; } return tc.call(this, u, i, x, y); };
        m.card('羽便伸臂令醫劈之。', '《關羽傳》');
        m.line('醫', '將軍，要劈了。');
        m.after(1.5, () => m.line('提示', '每一刀之前畫面會跳出要做的事：割炙（Q）、引酒（W）、言笑（E），時限內按對。不要移動。'));
        m.obj('poise', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        m.get('poise').text = `言笑自若（威儀 ${Math.round(V.poise)}%，第 ${Math.min(CUTS, V.cut + 1)}／${CUTS} 刀${V.cue ? '：' + ACTS[V.cue.k] : ''}）`;
        if (!V.sitting) { // 一動醫者就停手：坐回去才繼續
          m.chanAt(me, 'sit', SEAT[0], SEAT[1], 120, 1, '坐回', () => { V.sitting = true; V.at = [me.x, me.y]; V.nextT = 1.5; m.line('醫', '……將軍坐穩，接著來。'); });
          return false;
        }
        if (SG.gd(me.x, me.y, V.at[0], V.at[1]) > 30) {
          V.sitting = false; V.cue = null; V.poise -= 20;
          m.line('醫', '將軍莫動！'); m.line('部將', '……將軍的臉色變了。');
          return checkPoise(m);
        }
        if (V.cue) {
          V.cue.left -= dt;
          if (V.cue.left <= 0) { V.cue = null; V.miss++; V.poise -= 12; ouch(m, w); V.cut++; V.nextT = gapOf(V.cut); }
        } else if ((V.nextT -= dt) <= 0) {
          const k = Math.floor(SG.rand() * 3);
          V.cue = { k, left: Math.max(0.9, 1.6 - V.cut * 0.05) };
          m.big(ACTS[k]);
          m.line('醫', ['劈開了……', '刮——', '骨上的毒青黑青黑的。', '再一刀。'][V.cut % 4]);
          V.blood += 1;
          if (V.blood === Math.floor(CUTS / 2)) m.line('部將', '血都流滿盤子了……');
        }
        if (!checkPoise(m)) return false;
        return V.cut >= CUTS;
      },
    },
    { // 3. 此患乃除
      enter(m, w) {
        const V = m.vars;
        V.surgery = false; V.rain = 0.4;
        m.done('poise');
        m.line('醫', '毒刮乾淨了。此患乃除。');
        m.card('臂血流離，盈於盤器，而羽割炙引酒，言笑自若。', '《關羽傳》');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('關羽倒下'); },
  // 桌上的盤子：血越積越多
  ground(ctx, m, view, inView) {
    if (!inView(TABLE[0], TABLE[1], 200)) return;
    ctx.save();
    ctx.fillStyle = '#5a3a22'; ctx.fillRect(TABLE[0] - 120, TABLE[1] - 30, 240, 60);
    ctx.fillStyle = '#d8d0c0'; ctx.beginPath(); ctx.ellipse(TABLE[0] + 40, TABLE[1], 26, 12, 0, 0, Math.PI * 2); ctx.fill();
    const k = Math.min(1, (m.vars.blood || 0) / CUTS);
    if (k > 0) { ctx.fillStyle = '#8a1a14'; ctx.beginPath(); ctx.ellipse(TABLE[0] + 40, TABLE[1], 22 * k, 10 * k, 0, 0, Math.PI * 2); ctx.fill(); }
    ctx.restore();
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.rain) rain(ctx, view, x0, y0, vw, vh, m.vars.rain); },
};
const gapOf = (cut) => Math.max(1.5, 2.6 - cut * 0.08);
function ouch(m, w) { const me = w.player; w.dmgEvents.push({ x: me.x, y: me.y - 70, text: '……', team: 0, src: me.id }); }
// 按下一個動作
function press(m, w, i) {
  const V = m.vars, me = w.player;
  if (!V.sitting) return;
  if (!V.cue) { V.poise -= 3; return; } // 沒提示就亂動：小失態
  if (i === V.cue.k) {
    V.poise = Math.min(100, V.poise + 2);
    w.dmgEvents.push({ x: me.x, y: me.y - 70, text: ACTS[i].slice(0, 2), team: 0, src: me.id });
    if (i === 2 || SG.rand() < 0.3) { const L = TALK[(V.cut + i) % TALK.length]; m.line(L[0], L[1]); }
  } else { V.miss++; V.poise -= 8; ouch(m, w); }
  V.cue = null; V.cut++; V.nextT = gapOf(V.cut);
}
function checkPoise(m) {
  if (m.vars.poise > 0) return true;
  m.lose('色變——疼得變了臉色');
  return false;
}
